import { component as MODULE } from '../store/state';

const GETTERS = {
  USER: `${MODULE}user`,
};

export default GETTERS;
